var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shaddow-footer"},[(_vm.visible)?_c('v-footer',{staticClass:"overall",attrs:{"app":"","color":"white"}},[_c('v-container',{staticClass:"px-0"},[_c('TheHeaderMenu',{attrs:{"footer":true}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }